import React from 'react';
import PropTypes from 'prop-types';

export const MetaFormFragmentBase = ({ children, key }) => <React.Fragment key={key}>{children}</React.Fragment>;

MetaFormFragmentBase.defaultProps = {
  key: undefined,
};

MetaFormFragmentBase.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  key: PropTypes.string,
};
